import map from 'lodash/map';
import range from 'lodash/range';
import React from 'react';
import StarRatingStar from './star';
const StarRating = ({ stars = 0 }) => {
    const numStars = stars ? stars : 0;
    return (<div className="StarRating">
            {map(range(5), item => {
            return (<StarRatingStar key={item} hasForegroundStar={numStars > Number(item)} foregroundStarHalf={numStars >= Number(item) + 0.5 &&
                    numStars < Number(item) + 1} foregroundStarFilled={numStars >= Number(item) + 0.5}/>);
        })}
        </div>);
};
export default StarRating;
